import { gql } from '@apollo/client';

export const DASHBOARD_ECD_REGISTRATION_APPLICATIONS = gql`
  query DashboardEcdRegistrationApplications($input: DashboardFilterArgs) {
    totalApplicationPacksCollected(input: $input)
    totalApplicationsSubmitted(input: $input)
    totalOutstandingSubmissions(input: $input)
  }
`;
